import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database'
import { runtimeConfig } from './runtimeConfig'

if (!runtimeConfig.supabaseUrl) {
  throw new Error(
    'Missing VITE_SUPABASE_URL environment variable. Please add it to your .env.local file.'
  )
}

if (!runtimeConfig.supabasePublishableKey) {
  throw new Error(
    'Missing VITE_SUPABASE_PUBLISHABLE_KEY environment variable. Please add it to your .env.local file.'
  )
}

const finalUrl = runtimeConfig.supabaseUrl
const finalKey = runtimeConfig.supabasePublishableKey

export const supabase = createClient<Database>(finalUrl, finalKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // More secure for Single Page Applications
  },
  realtime: {
    params: {
      eventsPerSecond: 10, // Rate limiting for realtime subscriptions
    },
  },
})

// Note: Auth state change logging is handled in AuthProvider to avoid duplicate logs

// Helper function to check if user is authenticated
export const getCurrentUser = () => {
  return supabase.auth.getUser()
}

// Helper function to sign out
export const signOut = () => {
  return supabase.auth.signOut()
}
